import type { RowGroupId, ColumnId } from './common/types/index.tsx';

export const PRESENTATIONAL_FIELDKEYS: Record<string, ColumnId> = {
	DND: 'presentational__dnd',
	SELECT: 'presentational__select',
	ADD: 'presentational__add',
};

export const NO_VALUE_GROUP_ID: RowGroupId = 'table-no-value-group-id';
